<div class="form-group" [ngClass]="formGroupClass">
  <label [class]="labelClass" *ngIf="label">
    {{ label | translate }}
    <i *ngIf="requiredLabel" class="fa fa-asterisk form-required" aria-hidden="true"></i>
    <img
      *ngIf="!!infoTooltip"
      nz-tooltip
      nzTooltipColor="#ffffff"
      nzTooltipPlacement="top"
      nzTooltipOverlayClassName="normalize"
      [nzTooltipTitle]="infoTooltip | translate"
      class="info-icon"
      src="assets/icons/icon_info_gray_md.svg"
      alt="info bubble"
    />
  </label>
  <ng-select
    [class]="'custom ' + ngSelectClass"
    [items]="items.length > 0 ? items : (items$ | async)"
    [loading]="isLoading"
    [typeahead]="input$"
    [bindValue]="bindValue"
    [bindLabel]="labels && labels.length === 1 ? labels[0] : null"
    [formControl]="fc"
    [clearable]="clearable"
    [dropdownPosition]="dropdownPosition"
    [placeholder]="placeholder | translate"
    [multiple]="multiple"
    [hideSelected]="hideSelected"
    [closeOnSelect]="closeOnSelect"
    [searchable]="searchable"
    (open)="openEvent()"
    (change)="onChangeData($event)"
    (clear)="onClear()"
    (remove)="onRemove($event)"
  >
    <ng-template ng-label-tmp let-item="item" *ngIf="labels && labels.length > 1">
      <span *ngIf="multiple" aria-hidden="true" (click)="removeItem(item)" class="ng-value-icon left">×</span>
      <span class="ng-value-label">
        <span class="mr-1" *ngFor="let label of labels">{{ item[label] | translate }}</span>
      </span>
    </ng-template>
    <ng-template ng-label-tmp let-item="item" *ngIf="labels && labels.length === 1">
      <span *ngIf="multiple" aria-hidden="true" (click)="removeItem(item)" class="ng-value-icon left">×</span>
      <span class="ng-value-label">{{ item[labels[0]] | translate }}</span>
    </ng-template>
    <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index" *ngIf="options && options.length > 0">
      <ng-container
        [ngTemplateOutlet]="optionTemplate"
        [ngTemplateOutletContext]="{ item: item, item$: item$, index: index }"
      ></ng-container>
      <ng-container *ngIf="!optionTemplate">
        <span class="mr-1" *ngFor="let option of options">{{ item[option] }}</span>
      </ng-container>
    </ng-template>
  </ng-select>
  <app-control-errors *ngIf="fc" [control]="fc" [errors]="errors" [isShowHelper]="isShowHelper" [helper]="helper"></app-control-errors>
</div>
